import React from "react";

export enum DetailLevel {
  low,
  medium,
  high,
  all,
}

export const ResumeContext = React.createContext({
  detailLevel: DetailLevel.low,
  theme: "night-owl",
  setDetailLevel: (dl: DetailLevel) => {},
});
